import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import React, { memo, useMemo } from 'react';
import { ScrollView, StyleSheet, Text, View } from 'react-native';

export const CodeBlock = memo(
  ({ language, code }: { language: string; code: string }) => {
    const { rpx } = useResponsiveContext();
    const s = useMemo(
      () =>
        StyleSheet.create({
          codeContainer: {
            backgroundColor: '#1E293B',
            borderRadius: rpx(8),
            padding: rpx(12),
            marginVertical: rpx(6),
          },
          codeLang: {
            fontSize: rpx(10),
            color: '#94A3B8',
            fontFamily: 'Menlo',
            marginBottom: rpx(6),
          },
          codeText: {
            fontSize: rpx(12),
            lineHeight: rpx(18),
            color: '#E2E8F0',
            fontFamily: 'Menlo',
          },
        }),
      [rpx],
    );

    return (
      <View style={s.codeContainer}>
        {language ? <Text style={s.codeLang}>{language}</Text> : null}
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          <Text style={s.codeText}>{code}</Text>
        </ScrollView>
      </View>
    );
  },
);
